/*
 * File: EnrollStudentInPeriodWaitlist.ts
 * Author: Austin Robinson
 * Date Created: 7/18/2024
 * Copyright (c) DrivingDoc 2023
 */

import { ErrorResponse, privateApi } from 'api';
import { AxiosError } from 'axios';
import { createMutation } from "react-query-kit";

export type EnrollStudentInPeriodWaitlistParams = {
    coursePeriodId: string;
    studentId: string;
    enrollmentType: 'performance_and_observation' | 'observation_only';
}

export type EnrollStudentInPeriodWaitlistResult = object;


async function enrollStudentInPeriodWaitlist(params: EnrollStudentInPeriodWaitlistParams): Promise<EnrollStudentInPeriodWaitlistResult> {
    if (params === undefined) {
        return [];
    }

    // make api call
    const result = await privateApi.post('/courses/periods/enrollStudentInPeriodWaitlist', params);

    // return the data object
    return result.data;
}

const useEnrollStudentInPeriodWaitlist = createMutation<EnrollStudentInPeriodWaitlistResult, EnrollStudentInPeriodWaitlistParams, AxiosError<ErrorResponse>>({
    mutationFn: async (variables: EnrollStudentInPeriodWaitlistParams) => enrollStudentInPeriodWaitlist(variables),
});

export { enrollStudentInPeriodWaitlist, useEnrollStudentInPeriodWaitlist };
